import React, { useContext, useEffect, useState } from "react";
import { ConfirmDialog, useNotifications, ValidationResult } from "sprint-common-web";

import { OrderRequestStatus } from "../../../../common/types/OrderRequestStatus";
import { useOrdersModuleApi } from "../../../common/useOrdersModuleApi";
import { OrderRequestListingContext } from "../context/OrderRequestListingContext";
import { OrderRequestListingItem } from "../OrderRequestListingItem";
import { MoveOrderRequestToPendingValidationSummary } from "./MoveOrderRequestToPendingValidationSummary";

type MoveOrderRequestToPendingDialogProps = {
    item: OrderRequestListingItem;
    isOpen: boolean;
    onClose(): void;
};

export const MoveOrderRequestToPendingDialog: React.VFC<MoveOrderRequestToPendingDialogProps> = ({
    item,
    isOpen,
    onClose
}: MoveOrderRequestToPendingDialogProps) => {
    const { success, error } = useNotifications();
    const { moveOrderRequestToPending, validateMoveOrderRequestToPending } = useOrdersModuleApi();
    const { markAsChanged, updateOrderRequest } = useContext(OrderRequestListingContext);

    const [validationResult, setValidationResult] = useState<ValidationResult>();
    const [isValidating, setIsValidating] = useState<boolean>(true);

    useEffect(() => {
        if (isOpen) {
            validateMoveOrderRequestToPending({ orderRequestId: item.id })
                .then((result) => {
                    setValidationResult(result);
                })
                .finally(() => setIsValidating(false));
        }
    }, [isOpen]);

    const moveToPending = async () => {
        await moveOrderRequestToPending({ orderRequestId: item.id })
            .then(() => {
                markAsChanged(item.id);
                updateOrderRequest({ id: item.id, status: OrderRequestStatus.Pending });
                success("Order Request moved to Pending status succesfully");
            })
            .catch(() => {
                error("Order Request was not move to Pending status, please try again");
            })
            .finally(() => onClose());
    };

    return (
        <ConfirmDialog
            title="Move Order Request to Pending status"
            text="Are you sure you want move this Order Request to Pending status? This action is irreversible."
            hidden={!isOpen}
            confirm={{ onClick: moveToPending, disabled: !validationResult?.isValid }}
            cancel={{ onClick: onClose }}
        >
            <MoveOrderRequestToPendingValidationSummary
                validationResult={validationResult}
                isValidating={isValidating}
            />
        </ConfirmDialog>
    );
};
